import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {ActivityVisualTypesEnum} from '../../../../../models/api/activityModel';
import {AppState} from '../../../../../store/appState';
import {MessageViewerContainer} from '../message/messageViewerContainer';
import {SendingActivityViewerProps} from '../sendingActivityViewer';

/*
 * Props.
 */

interface SendingMessageViewerContainerProps extends SendingActivityViewerProps {
  messageUid: string;
}

/*
 * Selectors.
 */

function getMessageUid(_state: AppState, props: SendingMessageViewerContainerProps) {
  return props.messageUid;
}

function getPreviousMessageUid(_state: AppState, props: SendingMessageViewerContainerProps) {
  const {previousSendingActivity, lastActivity} = props;
  if (previousSendingActivity) {
    return previousSendingActivity.message && previousSendingActivity.message.uid;
  }

  if (lastActivity && lastActivity.visualType === ActivityVisualTypesEnum.MESSAGE) {
    return lastActivity.messageUid;
  }

  return undefined;
}

const mapStateToProps = makeMapStateToProps<SendingMessageViewerContainerProps>()(() => ({
  messageUid: getMessageUid,
  previousMessageUid: getPreviousMessageUid,
}));

/*
 * Redux.
 */

export const SendingMessageViewerContainer = connect(mapStateToProps)(MessageViewerContainer);
